import { useState } from "react";
import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table/interface";
import { IRemainingDetail, IRemainingSearchFields, IRemainingStatistics, remainingService } from "./remainingService";
import { DEFAULT_PAGE_SIZE, DEFAULT_FIRST_PAGE_NUM, defaultMdCmParam } from "@/utils/constants";
import { ISearchPage } from "@/types/FmsTypes";
import { transPgToPagination } from "@/views/base/app/appModel";
import { convertRes2Blob } from "@/utils/exportFile";


const defaultStatistics:IRemainingStatistics = {
    diffAmount: 0
}

export const useRemainingModel = createModel(function () {
    //列表数据源
    const [dataSource, setDataSource] = useState<IRemainingDetail[]>([]);
    //查询条件
    const [searchParam, setSearchParam] = useState<IRemainingSearchFields>({});
    //分页参数
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    //表格多选id值
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
    const [exportLoading, setExportLoading] = useState(false)
    const [statistics, setStatistics] = useState<IRemainingStatistics>(defaultStatistics)

    //设置搜索value
    const updateSearchParam = (updateParam: IRemainingSearchFields) => {
        if(updateParam.supplier === "1" || updateParam.supplier === "0"){
            setSearchParam({ ...searchParam, ...updateParam, partnerCode: undefined })
        } else {
            setSearchParam({ ...searchParam, ...updateParam })
        }
    }
    //列表查询
    const loadData = async (page: ISearchPage = initPgCfg, searchValue: IRemainingSearchFields = searchParam) => {
        const searchParams = {
            ...searchValue,
            sourceApp: defaultMdCmParam.sourceApp,
            page: {
                pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
                pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
            }
        }
        let { retData } = await remainingService.page(searchParams);
        let { retData: statis } = await remainingService.statistics(searchValue);
        const { records, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        setDataSource(records);
        setStatistics(statis)
        clearSelectData();
    }

    //重置搜索参数
    const resetSearchParam = () => {
        setSearchParam({});
        setSelectedRowKeys([]);
        loadData(initPgCfg, {});
    }
    const clearSelectData = () => {
        setSelectedRowKeys([]);
    }

    //导出
    const exportApi = async (page: ISearchPage = initPgCfg, searchValue: IRemainingSearchFields = searchParam) => {
        setExportLoading(true)
        try {
            const searchParams = {
                ...searchValue,
                sourceApp: defaultMdCmParam.sourceApp,
            }
            let result = await remainingService.export(searchParams);
            convertRes2Blob(result);
            setExportLoading(false)
        } catch (error) {
            setExportLoading(false)
        }
    }

    return {
        /***field***/
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg,
        exportLoading,
        statistics,
        /***method***/
        setDataSource,
        updateSearchParam,
        setSelectedRowKeys,
        resetSearchParam,
        loadData, exportApi
    }
});